import * as React from 'react'

function SvgNotifications(props, svgRef) {
  return (
    <svg viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        clipRule="evenodd"
        d="M8.5 20c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6V9c0-3.07-1.63-5.64-4.5-6.32V2C10 1.17 9.33.5 8.5.5S7 1.17 7 2v.68C4.14 3.36 2.5 5.92 2.5 9v5l-2 2v1h16v-1l-2-2zm-2 1h-8V9c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgNotifications)
export default ForwardRef
